export default "__VITE_ASSET__JV00NSRC__"